import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-orange-50 to-pink-50 flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-2xl p-12 text-center">
        <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-6" />
        <h1 className="font-heading uppercase text-3xl text-black mb-2">Pago cancelado</h1>
        <p className="text-gray-600 mb-6">No te preocupes, tu inscripción sigue guardada. Puedes intentar pagar de nuevo cuando quieras.</p>
        <Button onClick={() => navigate("/")} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="cancel-home-button">
          Volver al inicio
        </Button>
      </div>
    </div>
  );
}
